/**
 * @generated SignedSource<<20d806e060b0ba53cca9b0400eacc966>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EmploymentContractsType = "all" | "blank" | "none" | "some";
export type ErrorType = "ERR_ADSLOT" | "ERR_CARD_BIRTH" | "ERR_CARD_EXPIRED" | "ERR_CARD_NUMBER" | "ERR_CARD_PASSWORD" | "ERR_CARD_PASSWORD_FIVE_TIMES" | "ERR_CREATE_SURVEY_ANSWER" | "ERR_DUPLICATE_APPLY" | "ERR_ETC" | "ERR_EXIST_FINISH_REFUND" | "ERR_EXIST_SEARCH_HISTORY" | "ERR_EXPIRE_URL" | "ERR_HECTO_ETC" | "ERR_HOMETAX_BLOCK_ID" | "ERR_HOMETAX_CALCULATE" | "ERR_HOMETAX_COLLECT" | "ERR_HOMETAX_ETC" | "ERR_HOMETAX_EXPIRE_CERT" | "ERR_HOMETAX_IMPOSSIBLE" | "ERR_HOMETAX_INPUT" | "ERR_HOMETAX_NO_BMAN" | "ERR_HOMETAX_NO_CONTINUE_BMAN" | "ERR_HOMETAX_NO_CORPS_ID" | "ERR_HOMETAX_NO_INCOME_TAX" | "ERR_HOMETAX_NO_JUMIN_ID" | "ERR_HOMETAX_NO_REGIST_CERT" | "ERR_HOMETAX_NO_USER" | "ERR_HOMETAX_OVERLOAD" | "ERR_HOMETAX_PASSWORD" | "ERR_HOMETAX_PASSWORD_CHANGE_REQUEST" | "ERR_HOMETAX_REG_NO" | "ERR_HOMETAX_SERVER_FIX" | "ERR_HOMETAX_SESSION" | "ERR_HOMETAX_SIMPLE_AUTH" | "ERR_HOMETAX_TIMEOUT" | "ERR_LEAVE_REASON" | "ERR_LEAVE_REASON_LOG" | "ERR_NON_PRODUCT_PROMOTION" | "ERR_NOT_EXIST_HISTORY" | "ERR_NOT_EXIST_YEAR_END_TAX_SETTLEMENT" | "ERR_NO_EQUAL_TIN" | "ERR_PROMOTION" | "ERR_SSO" | "ERR_SURVEY" | "ERR_SURVEY_ANSWER" | "ERR_SURVEY_COMPLETED" | "ERR_SURVEY_EXPIRED" | "ERR_UPDATE_SURVEY_ANSWER" | "ERR_USER" | "ERR_USER_ACTION_LOG" | "ERR_USER_PHONE";
export type YesNoBlank = "blank" | "no" | "yes";
export type SurveyEmployeeInput = {
  attrYears: ReadonlyArray<string>;
  birthday?: string | null | undefined;
  ieNm: string;
  indvTin: string;
};
export type EmployeeWithoutTinInput = {
  birthday?: string | null | undefined;
  ieNm: string;
};
export type employmentUpdateMutation$variables = {
  hasEmploymentContracts?: EmploymentContractsType | null | undefined;
  hasSpecialRelationshipsInThePast?: YesNoBlank | null | undefined;
  isCompleted: boolean;
  specialRelationshipsCurrently?: ReadonlyArray<EmployeeWithoutTinInput> | null | undefined;
  specialRelationshipsInThePast?: ReadonlyArray<SurveyEmployeeInput> | null | undefined;
  surveyAnswerId: string;
};
export type employmentUpdateMutation$data = {
  readonly upsertEmploymentAnswer: {
    readonly errors: {
      readonly code: ErrorType;
      readonly message: string | null | undefined;
    } | null | undefined;
    readonly result: boolean;
  };
};
export type employmentUpdateMutation = {
  response: employmentUpdateMutation$data;
  variables: employmentUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasEmploymentContracts"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasSpecialRelationshipsInThePast"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isCompleted"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "specialRelationshipsCurrently"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "specialRelationshipsInThePast"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "surveyAnswerId"
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "hasEmploymentContracts",
        "variableName": "hasEmploymentContracts"
      },
      {
        "kind": "Variable",
        "name": "hasSpecialRelationshipsInThePast",
        "variableName": "hasSpecialRelationshipsInThePast"
      },
      {
        "kind": "Variable",
        "name": "isCompleted",
        "variableName": "isCompleted"
      },
      {
        "kind": "Variable",
        "name": "specialRelationshipsCurrently",
        "variableName": "specialRelationshipsCurrently"
      },
      {
        "kind": "Variable",
        "name": "specialRelationshipsInThePast",
        "variableName": "specialRelationshipsInThePast"
      },
      {
        "kind": "Variable",
        "name": "surveyAnswerId",
        "variableName": "surveyAnswerId"
      }
    ],
    "concreteType": "RefundUserPutSurveyAnswerOutput",
    "kind": "LinkedField",
    "name": "upsertEmploymentAnswer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Errors",
        "kind": "LinkedField",
        "name": "errors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "employmentUpdateMutation",
    "selections": (v6/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "employmentUpdateMutation",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "8ec1d084c6b934c2932f8de95b55463a",
    "id": null,
    "metadata": {},
    "name": "employmentUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation employmentUpdateMutation(\n  $surveyAnswerId: String!\n  $isCompleted: Boolean!\n  $hasSpecialRelationshipsInThePast: YesNoBlank\n  $specialRelationshipsInThePast: [SurveyEmployeeInput!]\n  $specialRelationshipsCurrently: [EmployeeWithoutTinInput!]\n  $hasEmploymentContracts: EmploymentContractsType\n) {\n  upsertEmploymentAnswer(surveyAnswerId: $surveyAnswerId, isCompleted: $isCompleted, hasSpecialRelationshipsInThePast: $hasSpecialRelationshipsInThePast, specialRelationshipsInThePast: $specialRelationshipsInThePast, specialRelationshipsCurrently: $specialRelationshipsCurrently, hasEmploymentContracts: $hasEmploymentContracts) {\n    result\n    errors {\n      code\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0d25d2c7026b747df125ad22222534e7";

export default node;
